module.exports = __webpack_public_path__ + "img/5.3b1649e4.png";